module.exports = __webpack_public_path__ + "img/ic-bell.9b2108fa.svg";